import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../Environment/environment';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  constructor(private http: HttpClient) {

  }

  // ---------------------- Get Order Summary List API ---------------------- //

  getOrderSummary(api: string) {
    return this.http.get(environment.baseUrl + api);
  }

  // ---------------------- Get Order Summary List Filter API  ---------------------- //

  getFilteredOrderSummary(
    api: string,
    userTypeId: any = null,
    cityId: any = null,
    zoneId: any = null,
    year: any = null,
    fromDate: any = null,
    toDate: any = null,
    month: any = null
  ) {
    let params: string = "";

    // Append each parameter if it's present
    if (cityId) {
      params += params ? `&cityId=${cityId}` : `?cityId=${cityId}`;
    }
    if (zoneId) {
      params += params ? `&ZoneId=${zoneId}` : `?ZoneId=${zoneId}`;
    }
    // if (month) {
    //   params += params ? `&Month=${month}` : `?Month=${month}`;
    // }
    if (year) {
      params += params ? `&Year=${year}` : `?Year=${year}`;
    }
    if (userTypeId) {
      params += params ? `&UserTypeId=${userTypeId}` : `?UserTypeId=${userTypeId}`;
    }

    if (fromDate) {
      params = params + (fromDate ? `?Fromdate=${fromDate}` : `&Fromdate=${fromDate}`)
    }

    if (toDate) {
      params = params + `&Todate=${toDate}`
    }

    const url = `${environment.baseUrl}${api}${params}`
    return this.http.get(url);
  }

  // --------------------- Get User Type List API --------------------- //

  getUserTypeList(api: string) {
    return this.http.get(environment.baseUrl + api)
  }

  // --------------------- Get User Summary API --------------------- //
  
  getUserSummaryById(api: string, userId: any, fromDate: any = null, toDate: any = null) {
    let params = `?userId=${userId}`;

    if (fromDate && toDate) {
      params += `&Fromdate=${fromDate}&Todate=${toDate}`;
    }

    const url = `${environment.baseUrl}${api}${params}`;
    console.log('Generated URL:', url);
    return this.http.get(url);
  }


  // --------------------- Get User Summary List API --------------------- //

  getAllUserSummary(api: string,
    userTypeId: any = null,
    cityId: any = null,
    zoneId: any = null,
  ) {

    let params: string = "";

    if (cityId) {
      params += params ? `&cityId=${cityId}` : `?cityId=${cityId}`;
    }
    if (zoneId) {
      params += params ? `&ZoneId=${zoneId}` : `?ZoneId=${zoneId}`;
    }
    if (userTypeId) {
      params += params ? `&UserTypeId=${userTypeId}` : `?UserTypeId=${userTypeId}`;
    }

    const url = `${environment.baseUrl}${api}${params}`
    return this.http.get(url);

  }

  // --------------------- Get Order List Summary API By (Date Filter) --------------------- //

  getOrderSummaryByDate(
    api: string,
    reqBody: any = null
  ) {
    // let params = new HttpParams();
    let params: string = "";

    if (reqBody.cityId) {
      params += params ? `&cityId=${reqBody.cityId}` : `?cityId=${reqBody.cityId}`;
    }
    if (reqBody.zoneName) {
      params += params ? `&zoneName=${reqBody.zoneName}` : `?zoneName=${reqBody.zoneName}`;
    }
    if (reqBody.fromDay) {
      params += params ? `&fromDay=${reqBody.fromDay}` : `?fromDay=${reqBody.fromDay}`;
    }
    if (reqBody.fromMonth) {
      params += params ? `&fromMonth=${reqBody.fromMonth}` : `?fromMonth=${reqBody.fromMonth}`;
    }
    if (reqBody.fromYear) {
      params += params ? `&fromYear=${reqBody.fromYear}` : `?fromYear=${reqBody.fromYear}`;
    }
    if (reqBody.toDay) {
      params += params ? `&toDay=${reqBody.toDay}` : `?toDay=${reqBody.toDay}`;
    }
    if (reqBody.toMonth) {
      params += params ? `&toMonth=${reqBody.toMonth}` : `?toMonth=${reqBody.toMonth}`;
    }
    if (reqBody.toYear) {
      params += params ? `&toYear=${reqBody.toYear}` : `?toYear=${reqBody.toYear}`;
    }
    if (reqBody.userId) {
      params += params ? `&userId=${reqBody.userId}` : `?userId=${reqBody.userId}`;
    }
    if (reqBody.userTypeId) {
      params += params ? `&userTypeId=${reqBody.userTypeId}` : `?userTypeId=${reqBody.userTypeId}`;
    }

    const url = `${environment.baseUrl}${api}${params}`;
    console.log('url', url)
    return this.http.get(url);
  }

}
